import React, { useState, useEffect } from "react";
import { Row, Container, Col, Form, Button, Modal, ButtonGroup } from "react-bootstrap";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaSearch } from "react-icons/fa";
import Image from 'react-bootstrap/Image';

const MedicalStaffPreview = (props) => {
    const { show, closeModal } = props;

    const { medicalStaffdata } = props;

    const closePreviewModal = () => {
        closeModal();
    }
    return (
        <Modal id="" show={show} animation={true} scrollable={true} size="lg">
            <Modal.Header closeButton onClick={() => closePreviewModal()}>
                <Modal.Title><h3 className="fs-20 mb-2 header_title text-black pt-3">Available Staff</h3></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row className="mb-3">
                        <Col lg='6'>
                            <div className="input-group">
                                <Form.Control type="text" id="activeSearchBar" placeholder="Search by Patient Name, Case No. or Contact No." />
                                <span className="input-group-addon"><FaSearch className='' /></span>
                            </div>
                        </Col>
                        <Col lg='3'></Col>
                        <Col lg='2'>
                            <span className="pull-right Dj mr-3 pt-2"><span><span className="ts">1</span>–<span className="ts">5</span></span> of <span className="ts">10</span></span>
                        </Col>
                        <Col lg='1'>
                            <div>
                                <ButtonGroup className="pull-right">
                                    <Button><FaArrowAltCircleLeft size='2rem' /></Button>
                                    <Button><FaArrowAltCircleRight size='2rem' /></Button>
                                </ButtonGroup>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg='12'>
                            <table id="activeCases" className="table table-striped table-hover text-nowrap dataTable no-footer" role="grid" aria-describedby="example_info">
                                <thead className="thead-light">
                                    <tr role="row">
                                        <th aria-controls="example" colspan="1">#</th>
                                        <th className="sorting_asc" aria-controls="example" colspan="1" aria-sort="ascending">Name</th>
                                        <th className="sorting" aria-controls="example" colspan="1">Email Id</th>
                                        <th className="sorting" aria-controls="example" colspan="1">Contact No.</th>
                                        <th className="sorting" aria-controls="example" colspan="1">Date Of Registration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {medicalStaffdata.map(function (d, idx) {
                                        return (
                                            <tr key={idx} role="row" className="odd">
                                                <td>
                                                    <Image
                                                        src={
                                                            (d.profilePictureData !== undefined && d.profilePictureData !== null && d.profilePictureData !== '') ?
                                                                d.profilePictureData :
                                                                "../img/profile-male.png"
                                                        }
                                                        className="rounded-circle w-32 mr-2" />
                                                </td>
                                                <td>{d.firstName} {d.lastName}</td>
                                                <td>{d.username}</td>
                                                <td>{d.phoneNumber}</td>
                                                <td>{d.approvedDate}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    )
}

export default MedicalStaffPreview;